<atx-date-picker
  [showWeekNumbers]="true"
  [weeksPresetData]="weeksPresetData"
  [minDate]="minWeekDate"
  [maxDate]="maxWeekDate"
  [startDate]="startDate"
  (dateSelect)="selectedDate$.next($event)"
></atx-date-picker>
